// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const getDateNoTimeZone = (inputDate: string | Date | null) => {
    if (!inputDate) {
        return null;
    }

    if (typeof inputDate === "string") {
        if (inputDate.indexOf("T") > -1) {
            return `${inputDate.split("T")[0]}T00:00:00` as any;
        }
        return inputDate as any;
    }
    return `${inputDate.toISOString().split("T")[0]}T00:00:00` as any;
};
